export default {
  main: {
    site_id: 18762167,
    enableWorldCup: true,
    title: 'Terminal PRO',
    isViewMode: true,
    showBetBuilderSection: true,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ['card'],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableTicketTimer: true,
    allowSportsAndVirtualsMix: false,
    timeFormat: 'HH:mm',
    bigWinAmount: 2556,
    enableWinterMode: false,
    showAdditionalCoin: false,
    additionalCoinMap: {
      'BGN': 'EUR',
      'EUR': 'BGN',
    },
    additionalCoinRate: 1.95583,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    fieldsToHide: {
      '@replace': true,
      enablePlaceBet: false,
      enableTaxOnStakeField: false,
      enableTaxOnReturnField: false,
      enableError: false,
      enableTotalWinField: false,
    },
    withdrawalRequest: {
      clientIds: {
        'EUR': 368707021,
        'BGN': 88834202
      },
      paymentSystemId: 17,
    },
    homeBannerSlides: [{ fileType: "webp", path: "/betting/prematch/all" }],
    temporaryBanner: 'advertisement',
    temporaryBannerSkin: 'efbet',
    temporaryBannerPath: 'betting/prematch/all/Soccer/World/18277589/27465623',
    temporaryBannerExperation: new Date(2025, 8, 1),
    homeMediaSlides: [
      {
        type: 'worldcup',
        path: 'worldcup',
        fileType: 'png'
      },
      {
        type: 'footballfortuna',
        path: 'thirdPartyGame/500009124',
      },
      {
        type: 'bonus',
        path: 'betting/prematch',
      },
      {
        type: 'enhanced-odds',
        path: 'betting/prematch',
        fileType: 'jpg',
      },
      {
        type: 'football-pro',
      },
      {
        type: 'talon',
      },
      {
        type: 'unbeatable-odds',
        path: 'betting/prematch',
      },
      {
        type: 'early-payout',
      },
      {
        type: 'virtual-games',
        path: 'betting/prematch/virtuals',
      },
      // {
      //   type: 'bonus-column',
      // },
      {
        type: 'bet-builder',
        path: 'betting/prematch/betBuilder',
      },
      {
        type: 'cashout',
      },

      {
        type: 'footballNew',
        path: 'betting/prematch/all/Soccer/World/all',
        fileType: 'png',
      },
    ],
    websitePasswordHash: 'd6c3c1223bfc72deaefaca731112f7371d28569a755401b8276f743432e6beb4',
    logoSize: '200x32',
    termsAndConditions: false,
    ticketPayoutExpirationDays: 30,
    enableGameInfo: true,
    useBetBookLastApi: false,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    availableLanguages: {
      '@replace': true,
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 3,
      },
      bgr: {
        short: 'BG',
        name: 'Bgr',
        region: 'Bulgaria',
        order: 1,
      },
      tur: {
        short: "TR",
        name: "Tür",
        order: 6,
      },
    },
  },
  footer: {
    enabled: false,
    isToggleable: true,
    texts: {
      logoText: 'Gambling is addictive. Please bet responsibly',
      termsText: '"BET BG" EAD (EIC: 206035800) is an organizer of gambling games regulated by the National Revenue Agency and licensed under the Gambling Act to organize bets on the results of sports competitions and horse and dog races with the following license: Certificate No. 000030- 1935 of 02/24/2022, reflecting the current state of the license issued by Decision No. 000030-1349 of 04/22/2021 of the National National Revenue Agency. Address: Bulgaria, Sofia, p.k. 1164, district Lozenets, 12 James Boucher Blvd.',
    },
    reservedText: '2023 All rights reserved',
    gamblingRules: {
      termsAndConditions: 'efBet/rules/gamblingRules.pdf',
    },
    termRules: {
      text: 'Terms and conditions',
      isOpen: true,
    },
    imagesArray: [
      'efbet/LogoImages/logo1',
      'efbet/LogoImages/logo2',
      'efbet/LogoImages/logo3',
      'efbet/LogoImages/logo4',
      'efbet/LogoImages/logo5',
      'efbet/LogoImages/logo6',
      'efbet/LogoImages/logo7',
      'efbet/LogoImages/logo8',
      'efbet/LogoImages/logo9',
      'efbet/LogoImages/logo10',
      'efbet/LogoImages/logo11',
      'efbet/LogoImages/logo12',
      'efbet/LogoImages/logo13',
    ],
    staticImages: {
      termsAndCondition: 'efbet/termsAndCondition',
      plusAge: 'efbet/plus18',
    },
    linksAndTitle: [
      {
        title: 'Terms & Conditions',
        childrens: [
          {
            title: 'NRA Terms & Conditions',
            link: 'efBet/rules/T_C_retail_BG.pdf',
          },
          {
            title: 'Specific Rules',
            link: 'efBet/rules/Specific_Rules.pdf',
          },
          {
            title: 'Games Terms and Conditions',
            link: 'efBet/rules/Specific_Rules.pdf',
          },
        ],
      },

      {
        title: 'About Us',
        childrens: [
          {
            title: 'License',
            link: 'efBet/rules/BETBG_license.pdf',
          },
          {
            title: 'About Us',
            link: 'efBet/rules/about_us.pdf',
          },
          {
            title: 'Network & Locations of Betshops',
            link: 'efBet/rules/Listwithshops_BetBG.pdf',
          },
        ],
      },

      {
        title: 'Company Policies',
        childrens: [
          {
            title: 'Responsible Gaming Policy',
            link: 'efBet/rules/Responsible_gaming_BetBG_rev.pdf',
          },
          {
            title: 'GDPR Policy',
            link: 'efBet/rules/GDPR_Policy_BetBG_EAD.pdf',
          },
          {
            title: 'Cookie Policy',
            link: 'efBet/rules/cookiePolicy.pdf',
          },
          {
            title: 'Complaints',
            link: 'efBet/rules/complaint.pdf',
          },
        ],
      },
      {
        title: 'News',
        childrens: [
          {
            title: 'News',
            link: 'https://efbetnews.com/ ',
          },
        ],
      },

      {
        title: 'Contact',
        childrens: [
          {
            title: '0700…..',
            link: 'efBet/rules/T_C_retail_BG.pdf',
            disabled: true,
          },
          {
            title: 'support@bet.b',
            link: 'aboutblank',
            disabled: true,
          },
          {
            title: 'Telegram',
            link: 'aboutblank',
            disabled: true,
          },
        ],
      },
    ],
  },
  env: {
    lang: 'bgr',
  },
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
  ],
  availableOdds: [
    {
      odds: 'american',
      title: 'American',
      enabled: true,
    },
    {
      odds: 'decimal',
      title: 'Decimal',
      enabled: true,
    },
    {
      odds: 'malay',
      title: 'Malaya',
      enabled: true,
    },
    {
      odds: 'indo',
      title: 'indo',
      enabled: true,
    },
    {
      odds: 'hongkong',
      title: 'hongkong',
      enabled: true,
    },
    {
      odds: 'fractional',
      title: 'Fractional',
      enabled: true,
    },
  ],
  routes: [
    {
      url: 'thirdPartyGame/500009124',
      name: 'Football Fortune',
      enabled: true,
    },
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: 'betting/live/all',
      name: 'Live',
      enabled: true,
    },
    {
      url: 'betting/prematch/all',
      name: 'Sports',
      type: 'sportsbook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    // {
    //   url: 'thirdParty/game/500009124',
    //   name: 'Football Fortuna',
    //   type: 'pascalGaming',
    //   enabled: true,
    //   iframeFullscreen: false,
    //   gameId: '500009124',
    //   gameWithSecondScreen: false,
    //   onlyInHeader: false,
    // },
    {
      url: 'betting/results',
      name: 'Results',
      enabled: true,
    },
    // {
    //   name: 'Virtual Games',
    //   url: 'thirdPartyGame/156147',
    //   type: 'virtualGames',
    //   enabled: true,
    //   nestedItems: [
    //     {
    //       url: 'thirdPartyGame/156147',
    //       name: 'Pascal Gaming',
    //       type: 'pascalGaming',
    //       enabled: true,
    //       iframeFullscreen: false,
    //       gameId: '156147',
    //       icon: 'casino-categories-PGgames',
    //       gameWithSecondScreen: false,
    //       onlyInHeader: false,
    //     }
    //   ],
    // },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },

  ],
  thirdParty: {
    gameConfig: {
      500009124: {
        useWebLauncher: true,
        hardcodedUrl: 'https://pg.rpd.cloud/cashier/?userType=4&partnerId=3043&partnerExternalId=18762167&currency=EUR&currencySymbol=%E2%82%AC&playerExternalId=4869452&businessUnitId=2&platformId=1',
        languageQueryParamName: 'culture'
      }
    }
  },
  defaultTerminalParams: {
    pid: 18762167, tid: 35226, token: 'Sf2VGQ==', currency: 'BGN',
  },
  sportsbook: {
    enableBoostedOdds: true,
    enableBetBuilderIcon: true,
    enablePredefinedMultiples: true,
  },
  betslip: {
    enableBankerBet: true,
    enableBookingBet: true,
    enableBookingId: true,
    betDetailsOrder: [
      'total_odd',
      'stake_without_tax',
      'total_stake',
      'min_possible_win',
      'possible_win',
      'bonus',
      'total_win',
    ],
  },
};
